import { render, staticRenderFns } from "./LabelSituacaoAcademica.vue?vue&type=template&id=66ad7e92&scoped=true&"
import script from "./LabelSituacaoAcademica.vue?vue&type=script&lang=js&"
export * from "./LabelSituacaoAcademica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad7e92",
  null
  
)

export default component.exports